import _Footer from './Footer';

import './style/index.js';

export type { FooterProps } from './Footer';
export * from './type';

export const Footer = _Footer;
export default Footer;
